var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.997,
    height: 20,
    viewBox: "0 0 19.997 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M24.172,11.981H13.518a1.834,1.834,0,0,0-1.832,1.832v7.419a1.83,1.83,0,0,0,1.832,1.827h6.1a.525.525,0,0,1,.365.154l3.029,2.793c.168.163.447.1.447-.139V23.434c0-.288.183-.38.471-.38h.048A2,2,0,0,0,26,21.227V13.813A1.824,1.824,0,0,0,24.172,11.981Z",
    transform: "translate(-2.628 -2.721)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M9.452,8.082h8.529V4.942a1.568,1.568,0,0,0-1.567-1.567H4.942A1.568,1.568,0,0,0,3.375,4.942v7.943a1.568,1.568,0,0,0,1.567,1.567H7.88V9.65A1.575,1.575,0,0,1,9.452,8.082Z",
    transform: "translate(0 0)",
    fill: "#08c4bb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconGreen);
export default __webpack_public_path__ + "static/media/chat-icon-green.5f1bd80cb82a92eaad5da4cd6b302787.svg";
export { ForwardRef as ReactComponent };